import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

const OAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const token = params.get("token");
    const id = params.get("id");
    const email = params.get("email");
    const name = params.get("name");
    const has_workspace = params.get("has_workspace");
    const profile_image = params.get("profile_image");

    // ❌ Invalid login → go back
    if (!token || !email) {
      navigate("/login");
      return;
    }

    // ✅ Save auth
    localStorage.setItem("token", token);

    localStorage.setItem(
      "user",
      JSON.stringify({
        id,
        name,
        email,
        has_workspace: has_workspace === "true",
      })
    );

    if (profile_image) {
      localStorage.setItem("profile_image", profile_image);
    } else {
   
      localStorage.removeItem("profile_image");
    }

    // ✅ Navigate (simple + safe)
    if (has_workspace === "true") {
      navigate("/home", { replace: true });
    } else if (has_workspace === "false") {
      navigate("/workspace", { replace: true });
    } else {
      // fallback
      checkWorkspace();
    }

    async function checkWorkspace() {
      try {
        const wsCheck = await api.get("/workspaces/check");

        if (wsCheck.data.hasWorkspace) {
          navigate("/home", { replace: true });
        } else {
          navigate("/workspace", { replace: true });
        }
      } catch (err) {
        console.error("Google login workspace check failed:", err);
        navigate("/login");
      }
    }
  }, [navigate]);

  return (
    <div className="text-center mt-5">
      Logging you in via Google...
    </div>
  );
};

export default OAuthCallback;
